module.exports = __webpack_public_path__ + "img/kr-product-final-card3-left-img.bea1c35.png";